export const START_FETCH_CONTACT_NOTES = 'START_FETCH_CONTACT_NOTES'
export const SUCCESS_FETCH_CONTACT_NOTES = 'SUCCESS_FETCH_CONTACT_NOTES'
export const FAILED_FETCH_CONTACT_NOTES = 'FAILED_FETCH_CONTACT_NOTES'

import fetchContactNotesCTRL from 'controllers/contactTimeline/fetchContactNotesList'

export function fetchContactNotes(contactId, callback){

  return function(dispatch) {

    dispatch({
      type: START_FETCH_CONTACT_NOTES,
      payload: {
        fetching: true,
      }
    })

    fetchContactNotesCTRL(contactId)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_CONTACT_NOTES,
        payload: {...result, fetching: false, hasPermission: true}
      })

      if(typeof(callback) == 'function'){
        callback()
      }

    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_CONTACT_NOTES,
        payload: {err, hasPermission: false, fetching: false}
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/ContactNotes/redux/actions/fetchContactNotes.js